import type { ParcelFormValues } from './useParcelFormSchema';
import { parcelFormSchema } from './useParcelFormSchema';

/**
 * Schema do formulário de edição de parcela.
 *
 * É o `parcelFormSchema` compartilhado, **sem** o `superRefine` da recorrência: o
 * `PUT` de edição não tem `multiple` nem `amountOfParcel` — o endpoint gera cópias
 * só na criação —, então a tela não renderiza o bloco e a regra não se aplica.
 */
export const parcelEditSchema = parcelFormSchema;

/** Valores do formulário de edição de parcela. */
export type ParcelEditFormValues = ParcelFormValues;
